var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('button',{staticClass:"sd-btn",staticStyle:{"margin-left":"20px","margin-top":"20px"},on:{"click":function($event){return _vm.savePdf()}}},[_vm._v("Save as PDF")]),_c('survey',{attrs:{"survey":_vm.survey}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }